import { useState } from 'react';

import {
    getOverrideProps,
    getOverridesFromVariants,
    mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";

import { CommonBtnWhite } from '../ui-components';

export default function CommonBtnWhiteWrapper(props) {
    const { overrides: overridesProp, ...rest } = props;
    const variants = [];
    const overrides = mergeVariantsAndOverrides(
        getOverridesFromVariants(variants, props),
        overridesProp || {}
    );
    const [situation, setSituation] = useState("default");
    
    function onMouseEventEnter(){
        setSituation("hover")
    }

    function onMouseEventLeave(){
        setSituation("default")
    }

    return (
        <CommonBtnWhite
            onClick={props.onClick}
            onMouseEnter={onMouseEventEnter}
            onMouseLeave={onMouseEventLeave}
            situation={situation}
            overrides={{
                text: {
                    children: props.children,
                }
            }}
            {...getOverrideProps(overrides, "CommonBtnWhite")}
        >
        </CommonBtnWhite>
    );
}